import axios from "axios";

const generateInformInstallJobNo = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/InformInstallJobs/GanerateInformInstallJobNo`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const createInformInstallJobs = async (inform) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/InformInstallJobs`, inform)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllInformInstallJobs = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/InformInstallJobs`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllInformInstallJobsDropdown = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/InformInstallJobs/installDocNo?Inform_Install_Status=OPEN`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllInformInstallJobsDetail = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/InformInstallJobs/installDocNo/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getInformInstallJobsItem = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/InformInstallJobs/items/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getInformInstallJobs = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/InformInstallJobs/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editInformInstallJobs = async (id, inform) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/InformInstallJobs/${id}`, inform)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteInformInstallJobs = async (id, force) => {
  return axios
    .delete(
      `${process.env.REACT_APP_API_URL}/InformInstallJobs/${id}?force=${force}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const exportInformInstallJobs = async (body) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/seqInstallJob/create`, body
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editSeqStatus = async (id, seq_status_id) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/seqinstalljob/${id}`, { seq_status_id: seq_status_id })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const InformInstallJobsService = {
  generateInformInstallJobNo,
  createInformInstallJobs,
  getAllInformInstallJobs,
  getInformInstallJobs,
  editInformInstallJobs,
  deleteInformInstallJobs,
  getAllInformInstallJobsDropdown,
  getAllInformInstallJobsDetail,
  getInformInstallJobsItem,
  exportInformInstallJobs,
  editSeqStatus
};

export default InformInstallJobsService;
